export default __webpack_public_path__ + "static/media/visa.923df93e.svg";